import Page404 from '../pages/404'
import PageList from '../pages/list'

const routes = [
  {
    name: 'index',
    path: '/',
    alias: '/index',
    props: true,
    component: PageList,
    meta: {
      title: '早盘指导'
    }
  },{
    name: 'list',
    path: '/list',
    props: true,
    component: PageList,
    meta: {
      title: '早盘指导'
    }
  },
  {
    name: '404',
    path: '*',
    component: Page404
  }
]

// add route path
routes.forEach(route => {
  route.path = route.path || '/' + (route.name || '')
})

export default routes
